<template>
    <div class="student-task-list-page">
        <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">TUGAS SISWA</h6>
                </div>
                <div class="col-lg-6 text-lg-right">
                </div>
            </div>
            <div class="text-center text-muted">
                <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="p-2">
                        <b-row>
                            <b-col lg="2" class="my-1">
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                            </b-col>
                            <b-col lg="6" class="my-1">
                            </b-col>
                            <b-col lg="4" class="my-1">
                                <b-input-group size="sm">
                                    <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Cari"
                                    ></b-form-input>

                                    <b-input-group-append>
                                        <b-button style="border-radius:0px !important;" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-table
                            :items="studentTaskList"
                            :fields="fields"
                            :busy="isBusy"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            responsive="sm"
                            show-empty
                            small
                            @filtered="onFiltered"
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #cell(image_path)="row">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="avatar rounded-circle">
                                        <img alt="" height="50px" :src="row.item.image_path">
                                    </a>
                                </div>
                            </template>
                            <template #cell(full_name)="row">
                                <div class="list-murid text-left">
                                    <label>{{row.item.full_name}} ({{row.item.email}})</label>
                                    <div class="text-muted"><i class="fa fa-clock" aria-hidden="true"></i> {{row.item.created}}</div>
                                    <div class="d-flex">
                                        <div class="mr-1"><b-badge :variant="row.item.remark_color">{{row.item.remark}}</b-badge></div>
                                        <div class="ml-1"><i class="fa fa-calendar" aria-hidden="true"></i> Nilai: <b-badge v-if="row.item.scores == 'Belum dinilai'" :variant="row.item.score_color">{{row.item.scores}}</b-badge> <label v-else>{{row.item.scores}}</label></div>
                                    </div>
                                </div>
                            </template>

                            <template #cell(actions)="row">
                                <div class="my-2" v-if="row.item.is_admin==1 && row.item.is_has_collected_task == 1">
                                    <a href="javascript:void(0)" v-b-tooltip.hover title="Lihat Detail Tugas" class="icon-clicked p-1" @click="showStudentTaskDetail(row.item)"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                    <a href="javascript:void(0)" v-b-tooltip.hover title="Reset" class="icon-clicked p-1" @click="confirmReset(row.item.id)"><i class="fa fa-cogs" aria-hidden="true"></i></a>
                                    <a href="javascript:void(0)" v-b-tooltip.hover title="Berikan Penilaian" class="icon-clicked p-1" @click="showTaskAppraisalFormModal(row.item.id)"><i class="fa fa-calendar-check" aria-hidden="true"></i></a>
                                </div>
                            </template>
                        </b-table>
                        <div class="d-flex justify-content-lg-end justify-content-center py-2">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </card>
		<b-modal
			ref="student-task-detail-modal"
			class="student-task-detail-modal"
			size="lg"
            title="Tugas Siswa"
			hide-footer
			no-close-on-backdrop
		>
            <div class="student-task-detail">
                <div class="card">
                    <div class="card-header">
                         <div class="d-flex">
                            <div class="left-content mr-2">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="avatar rounded-circle">
                                        <img alt="" :src="studentTaskDetail.tutor_image_path">
                                    </a>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="user-article">
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.tutor_full_name"></a>&nbsp;
                                    <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>&nbsp;
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.judul_task"></a>
                                </div>
                                <div class="role-article">
                                    <small class="text-muted" v-html="studentTaskDetail.created"></small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="studentTaskDetail.is_file==1" class="card-body">
                        <div v-if="studentTaskDetail.file_type=='video'">
                            <video-embed :src="studentTaskDetail.file_path"></video-embed>
                        </div>
                        <div v-else style="text-align:center">
                            <iframe :src="studentTaskDetail.view_link" width="100%" height="500"></iframe>
                        </div>
                    </div>
                    <div v-else class="card-body" v-html="studentTaskDetail.description_task"></div>
                    <div class="card-footer">
                        <a href="javascript:void(0)" class="btn-open-answer" v-b-toggle="'collapse-task-answer'"><i class="fa fa-file" aria-hidden="true"></i> Lembar Jawaban Siswa</a>
                    </div>
                    <b-collapse :id="'collapse-task-answer'" class="p-4">
                        <div class="d-flex">
                            <div class="left-content mr-2">
                                <div class="media d-flex justify-content-center">
                                    <a href="javascript:void(0)" class="avatar rounded-circle">
                                        <img alt="" :src="studentTaskDetail.siswa_image_path">
                                    </a>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="user-article">
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.siswa_full_name"></a>&nbsp;
                                    <!-- <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>&nbsp;
                                    <a href="javascript:void(0);" class="text-uppercase font-weight-bold" v-html="studentTaskDetail.answer"></a> -->
                                </div>
                                <div class="role-article">
                                    <small class="text-muted" v-html="studentTaskDetail.created"></small>
                                </div>
                                <div class="answer-content py-3" v-html="studentTaskDetail.answer">
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
		</b-modal>
		<b-modal
			ref="task-appraisal-form-modal"
			class="task-appraisal-form-modal"
			size="md"
            title="Form Penilaian"
            @show="resetTaskApprasialForm"
            @hidden="resetTaskApprasialForm"
			hide-footer
			no-close-on-backdrop
		>
            <div class="task-appraisal-form">
                <b-form data-vv-scope="task-appraisal-form">
                    <b-form-group
                        label="Nilai"
                        label-for="title"
                        label-cols-sm="3"
                        label-align-sm="left"
                    >
                        <b-form-input
                            id="value"
                            name="value"
                            data-vv-as="Nilai"
                            v-model="task_appraisal_form.score"
                            type="text"
                            placeholder="Nilai"
                            v-validate="'required|max_value: 100'"
                            autocomplete="off"
                            @keypress="isNumber($event)"
                        ></b-form-input>
                        <span :class="{ 'error-validation': errors.first('task-appraisal-form.value') }">{{ errors.first('task-appraisal-form.value') }}</span>
                    </b-form-group>
                    <b-form-group
                        label="Catatan"
                        label-for="note"
                        label-cols-sm="3"
                        label-align-sm="left"
                    >
                        <b-form-textarea
                            id="note"
                            name="note"
                            data-vv-as="Catatan"
                            v-model="task_appraisal_form.note"
                            placeholder="Catatan"
                            v-validate="''"
                            rows="3"
                            max-rows="6"
                            no-resize
                        ></b-form-textarea>
                        <span :class="{ 'error-validation': errors.first('task-appraisal-form.note') }">{{ errors.first('task-appraisal-form.note') }}</span>
                    </b-form-group>
                </b-form>
                <hr>
                <div class="new-class-footer d-flex justify-content-end">
                    <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
                    <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideTaskAppraisalFormModal">BATAL</b-button>
                    <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveTaskAppraisal">SIMPAN</b-button>
                </div>
            </div>
		</b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                isBusy: false,
                showLoader: false,
                items: [
                    { isActive: true, age: 40, name: { first: 'Dickerson', last: 'Macdonald' } },
                    { isActive: false, age: 21, name: { first: 'Larsen', last: 'Shaw' } },
                    {
                        isActive: false,
                        age: 9,
                        name: { first: 'Mini', last: 'Navarro' },
                        _rowVariant: 'success'
                    },
                    { isActive: false, age: 89, name: { first: 'Geneva', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'Jami', last: 'Carney' } },
                    { isActive: false, age: 27, name: { first: 'Essie', last: 'Dunlap' } },
                    { isActive: true, age: 40, name: { first: 'Thor', last: 'Macdonald' } },
                    {
                        isActive: true,
                        age: 87,
                        name: { first: 'Larsen', last: 'Shaw' },
                        _cellVariants: { age: 'danger', isActive: 'warning' }
                    },
                    { isActive: false, age: 26, name: { first: 'Mitzi', last: 'Navarro' } },
                    { isActive: false, age: 22, name: { first: 'Genevieve', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'John', last: 'Carney' } },
                    { isActive: false, age: 29, name: { first: 'Dick', last: 'Dunlap' } }
                ],
                fields: [
                    { key: 'image_path', label: 'Foto', sortable: false, class: 'foto-field'},
                    { key: 'full_name', label: 'Daftar Kumpul Tugas', sortable: true, sortDirection: 'desc', class: 'text-center' },
                    { key: 'actions', label: 'Aksi', class: 'action-field' }
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                task_appraisal_form: {
                    id: null,
                    score: null,
                    note: null
                },
                nilai: null
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                studentTaskList: 'getStudentTaskList',
                studentTaskDetail: 'getStudentTaskDetail'
            })
        },
        methods: {
            showTaskAppraisalFormModal(id) {
                this.$nextTick(() => {
                    this.task_appraisal_form.id = id
                });
                this.$refs['task-appraisal-form-modal'].show()
            },
            hideTaskAppraisalFormModal() {
                this.$refs['task-appraisal-form-modal'].hide()
                this.resetTaskApprasialForm()
            },
            showStudentTaskDetailModal() {
                this.$refs['student-task-detail-modal'].show()
            },
            hideStudentTaskDetailModal() {
                this.$refs['student-task-detail-modal'].hide()
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            resetTaskApprasialForm() {
                this.task_appraisal_form.id = null
                this.task_appraisal_form.score = null
                this.task_appraisal_form.note = null
                this.$validator.reset()
            },
            async showStudentTaskDetail(param) {
                EventBus.$emit('showLoaderOverlay', true)
                let taskId = param.task_id
                let userId = param.user_id
				await this.$store.dispatch('getStudentTaskDetail', { taskId, userId })
					.then( async () => {
                        await EventBus.$emit('hideLoaderOverlay', true)
                        await setTimeout(() => this.showStudentTaskDetailModal(), 1000);
					})
					.catch((err)=> {
                        EventBus.$emit('hideLoaderOverlay', true)
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
			async getStudentTaskList() {
                this.isBusy = true
                let taskId = this.$route.params.taskId
                let taId = this.$route.params.taId
				await this.$store.dispatch('getStudentTaskList', { taskId,taId })
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
			async saveTaskAppraisal() {
                let scope = 'task-appraisal-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        let form = this.task_appraisal_form
                        this.showLoader = true
                        this.$store.dispatch('taskAssesment', form)
                            .then((res) => {
                                this.showLoader = false
                                this.getStudentTaskList()
                                this.hideTaskAppraisalFormModal()
                                this.$swal.fire('Success', res.message, 'success')
                            })
                            .catch((err)=> {
                                let error = err.response
                                this.showLoader = false
                                // if (error.status == 400) {
                                //     this.errorValidate(error.data, scope)
                                // } else {
                                    this.$swal.fire('Failed', error.data.message, 'error')
                                // }
                            })
                    }
                });
			},
            confirmReset(id) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.resetTask(id)
                    }
                })
            },
            async resetTask(id) {
				await this.$store.dispatch('resetTask', { id })
					.then((res) => {
                        this.getStudentTaskList()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            }
        },
        mounted() {
            this.totalRows = this.studentTaskList.length
        },
        async created() {
            await this.getStudentTaskList()
        }
    }
</script>
<style lang="css" scoped>
.line-with-icon svg {
    /* color: #adb7be; */
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
}
.line-with-icon {
    position: relative;
    padding: 0 0 0 1.75em;
    margin: 0 0 1em;
}
.user-article a {
    color: black;
}
.class-list > .line-with-icon > a{
    color:#ca062a
}
.user-article a:hover {
    color: #ca062a;
}

.btn-open-answer {
    color: #6c757d
}
.btn-open-answer:hover {
    color: #ca062a;
}
</style>